/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useContext } from "react";
import { PanelsContext } from "../Context/PanelsContext";
import { useOutsideAlerter } from "./GlobalComponents/HandleClick";
import Row from "./GlobalComponents/Row";
import Title from "./GlobalComponents/Title";
import SubTitle from "./GlobalComponents/SubTitle";
import BoxColor from "../components/GlobalComponents/BoxColor";
import ColorPicker from "./GlobalComponents/ColorPicker";

const ColorSettings = () => {
  const {
    textColor,
    setTextColor,
    textColorRef,
    openTextColor,
    setOpenTextColor,
    textBackground,
    setTextBackground,
    textBgRef,
    openTextBg,
    setOpenTextBg,
    iconBackground,
    setIconBackground,
    iconBgRef,
    openIconBg,
    setOpenIconBg,
  } = useContext(PanelsContext);

  useOutsideAlerter(textColorRef, () => setOpenTextColor(true));
  useOutsideAlerter(textBgRef, () => setOpenTextBg(true));
  useOutsideAlerter(iconBgRef, () => setOpenIconBg(true));

  return (
    <div css={styles} className="colorSettings">
      <Row>
        <Title title="Text" />
      </Row>
      <Row>
        <SubTitle text="Text Color" />
        <div ref={textColorRef} className="colorPicker">
          <BoxColor
            bgColor={textColor}
            pickerHidden={!openTextColor}
            setPickerHidden={setOpenTextColor}
          />
          {!openTextColor && (
            <ColorPicker color={textColor} setPickerChange={setTextColor} />
          )}
        </div>
      </Row>
      <Row>
        <SubTitle text="Text Background Color" />
        <div ref={textBgRef} className="colorPicker">
          <BoxColor
            bgColor={textBackground}
            pickerHidden={!openTextBg}
            setPickerHidden={setOpenTextBg}
          />
          {!openTextBg && (
            <ColorPicker
              color={textBackground}
              setPickerChange={setTextBackground}
            />
          )}
        </div>
      </Row>
      <Row>
        <Title title="Background" />
      </Row>
      <Row>
        <SubTitle text="Icon Background Color" />
        <div ref={iconBgRef} className="colorPicker">
          <BoxColor
            bgColor={iconBackground}
            pickerHidden={!openIconBg}
            setPickerHidden={setOpenIconBg}
          />
          {!openIconBg && (
            <ColorPicker
              color={iconBackground}
              setPickerChange={setIconBackground}
            />
          )}
        </div>
      </Row>
    </div>
  );
};

const styles = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .row {
    &:nth-child(1),
    &:nth-child(4) {
      max-width: 100%;
    }
    .colorPicker {
      position: relative;
    }
  }
`;

export default ColorSettings;
